import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { Outlet } from 'react-router-dom';

import packageJson from '../../../package.json';

const { Content, Footer } = Layout;
const { Title } = Typography;

const AuthLayout: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: '50px 0' }}>
        <div style={{ maxWidth: '480px', margin: '0 auto' }}>
          <Space orientation="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
            {/* This renders the child route components */}
            <Outlet />
          </Space>
        </div>
      </Content>

      <Footer style={{ textAlign: 'center', background: 'transparent' }}>
        <div style={{ fontSize: '12px', color: '#888' }}>
          Version: {packageJson.version || '1.0.0'} | &copy; {new Date().getFullYear()} LHPH Capital
        </div>
      </Footer>
    </Layout>
  );
};

export default AuthLayout;
